'use client';

import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import NoData from '@/components/common/no-data/NoData';
import { Skeleton } from '@/components/ui/skeleton';
import useGetOrganization from '@/hooks/queries/organization/useGetOrganization';
import { useRootStore } from '@/providers/root-store-provider';
import { VEPCodes } from '@/utils/utils';
import { useParams } from 'next/navigation';
import React from 'react';
import NewBookingSectionVp from '../new-booking-section-vp/NewBookingSectionVp';
import NewBookingSection from '../new-booking-section/NewBookingSection';
import NotFound from '@/app/[locale]/not-found';

const NewBookingContainer: React.FC = () => {
  const hasHydrated = useRootStore((state) => state.hasHydrated);
  const params = useParams<{ organizationName: string; locale: string }>();
  const {
    data: organization,
    error,
    isError,
    isPending
  } = useGetOrganization(params.organizationName);

  if (error?.response?.status === 404) {
    return <NotFound />;
  }

  if (isPending || !hasHydrated) {
    return (
      <>
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-10 mt-8" />
        <Skeleton className="w-full h-10 mt-8" />
        <Skeleton className="w-full h-10 mt-8" />
      </>
    );
  }

  if (!organization) return <NoData />;

  if (isError) {
    return <ErrorMessage />;
  }

  // New booking for Viento en Popa Org
  if (VEPCodes.includes(organization.code)) {
    return <NewBookingSectionVp organization={organization} />;
  }

  return <NewBookingSection organization={organization} />;
};

export default NewBookingContainer;
